import axios from 'axios'
import {Main} from '../../../Logic/Main'
import {Logic} from '../../../Logic/Type'
import * as Config from '../../../Logic/Config'
import * as Index from '../../../Logic/Index'
import * as Assets from '../../../Assets/Assets'
import * as Rest from '../../../Logic/Database/Rest'

function getLevels(site: string) {
  axios.get(Config.promostoreServerLevels + '?site_id=' + site)
  .then(response => {
    if (response.data) {
      axios.get(Config.promostoreServerSublevels + '?site_id=' + site)
      .then(response2 => {
        Logic.Type.New (Main.Instance.IndexState, {
          Levels: response.data, 
          LevelsCountCalled: false, 
        })
      }).catch ((err) => console.log(err))
    }
  }).catch ((err) => console.log(err))
}

export function Init(callback0?: (a: boolean) => void, callback?: () => void, callback1?: () => void): JSX.Element {
  let subdomain, hostname :string
  let url = window.location.hostname
  if (url !== 'localhost') {
      hostname = url.replace('https://','').split('.', 1)[0]
      if (hostname === 'test') subdomain = Config.subdomain
      else subdomain = hostname
  } else subdomain = Config.subdomain
  // console.log (subdomain)
  axios.get(Config.adminServerTestSiteData + '?subdomain=' + subdomain)
  .then(response => {
    // console.log (response.data)

    if (response.data) {
      axios.get(Config.promostoreLanguage + '?site_id=' + response.data.site_id + '&offset=0&limit=9999&filter_active=0')
      .then((response0) => {
        // console.log (response0.data)
        let shopItems: Index.ShopItem[] = []
        let Sql: string = Config.promostoreServerShopItems + '?site_id=' + response.data.site_id
        + '&sort_active=' + Main.Instance.IndexState.sortActive
        + '&sort_price=' + Main.Instance.IndexState.sortPrice
        + '&sort_name=' + Main.Instance.IndexState.sortName
        + '&sort_discount=' + Main.Instance.IndexState.sortDiscount
        axios.get(Sql)
        .then(response2 => {
/*
        let menus: string[] = Object.assign ([], response.data.menus)
        let menus_type: string[] = Object.assign ([], response.data.menus_type)
*/
        for (let i: number = 0; i < response2.data.length; i++) {
            let title: string = response2.data[i].name
            let active: boolean
            if (Main.Instance.SearchState.Gamification.length > 0 && -1 ===
                title.toLowerCase().indexOf(Main.Instance.SearchState.Gamification.toLowerCase())) {
                active = false
            } else {
              active = true
            }
            // if (response2.data[i].name[0] === 'Lost Relics 25 free spins') console.log (response2.data[i])
            shopItems.push({
              fromtime: response2.data[i].fromtime,
              totime: response2.data[i].totime,
              players: response2.data[i].players,
              id: response2.data[i].id,
              multi: response2.data[i].buyable,
              newly: response2.data[i].only_newly_registered,
              free_round: response2.data[i].free_round,
              title: response2.data[i].name,
              image: response2.data[i].image && response2.data[i].image.length > 0 ?
              response2.data[i].image : response.data.default_image,
              price: parseInt(response2.data[i].price),
              banner: parseInt(response2.data[i].banner),
              category: parseInt(response2.data[i].category),
              idx: i,
              t_c: response2.data[i].info,
              info: response2.data[i].info2,
              index: parseInt(response2.data[i].index),
              active: active && response2.data[i].active,
              discountedPrice: Math.round(parseInt(response2.data[i].price) * (1 - parseInt(response2.data[i].discount) / 100)),
              discount: parseInt(response2.data[i].discount)})
        }

        getLevels(response.data.site_id)

        let Length: number = 0
        let oneslash: number = 0
        if (window.location.href.indexOf ('player=') !== -1) {
            let oneSlash: boolean = false
            for (let i: number = window.location.href.length - 1; i >= 0; i--) {
                if (oneSlash === false && window.location.href.charAt(i) === '/') {
                    oneslash++
                    oneSlash = true
                    continue
                } else if (oneSlash === false) {
                    oneslash++
                    continue
                }

                if (window.location.href.charAt(i) === '='
                    && window.location.href.charAt(i - 1) === 'r'
                    && window.location.href.charAt(i - 2) === 'e'
                    && window.location.href.charAt(i - 3) === 'y'
                    && window.location.href.charAt(i - 4) === 'a'
                    && window.location.href.charAt(i - 5) === 'l'
                    && window.location.href.charAt(i - 6) === 'p'
                ) break
                Length++
            }
        }

        let player: string = ''
        for (let i: number = window.location.href.length - Length - oneslash; i < window.location.href.length - oneslash; i++)
        player += window.location.href.charAt(i)
        if (player.length === 0) player = '0'

        let length: number = 0
        for (let i: number = window.location.href.length - 1; i >= 0; i--) {
          if (window.location.href.charAt(i) === '/') break
          length++
        }

        let transactions: boolean = false

        if (length === 4) {
          let char = window.location.href[window.location.href.length - 4]
          if (char === 't' || char === 'T') transactions = true
        } else if (length === 3) {
          let char = window.location.href[window.location.href.length - 3]
          if (char === 't' || char === 'T') transactions = true
        } else if (length === 1) {
          let char = window.location.href[window.location.href.length - 1]
          if (char === 't' || char === 'T') transactions = true
        }

        let default_language: number = Assets.LANGUAGE_SCANDIBET.EUROPE
        if (length >= 2) {
          let l = window.location.href[window.location.href.length-2] + window.location.href[window.location.href.length-1]
          if (l.toLowerCase() === 'sv') default_language = Assets.LANGUAGE_SCANDIBET.SWEDEN
          else if (l.toLowerCase() === 'no') default_language = Assets.LANGUAGE_SCANDIBET.NORWAY
          else if (l.toLowerCase() === 'fi') default_language = Assets.LANGUAGE_SCANDIBET.FINLAND
          else if (l.toLowerCase() === 'en') default_language = Assets.LANGUAGE_SCANDIBET.EUROPE
          else if (l.toLowerCase() === 'nz') default_language = Assets.LANGUAGE_SCANDIBET.NEW_ZEALAND
          else if (l.toLowerCase() === 'ca') default_language = Assets.LANGUAGE_SCANDIBET.CANADA
          else if (l.toLowerCase() === 'gb') default_language = Assets.LANGUAGE_SCANDIBET.GREAT_BRITAIN
          else if (l.toLowerCase() === 'da') default_language = Assets.LANGUAGE_SCANDIBET.DENMARK
        }

        const imageLanguage: number = 
            default_language !== Assets.LANGUAGE_SCANDIBET.SWEDEN && 
            default_language !== Assets.LANGUAGE_SCANDIBET.NORWAY &&
            default_language !== Assets.LANGUAGE_SCANDIBET.FINLAND && 
            default_language !== Assets.LANGUAGE_SCANDIBET.DENMARK ? 0 : default_language
        let sql: string = Config.adminServerImages + '?subdomain=' + subdomain + '&language=' + imageLanguage
        axios.get(sql)
        .then ((responseImages) => {
            Logic.Type.New(Main.Instance.IndexState, {
                  custom: response.data.custom,
                  languages: response0.data,
                  RewardShopMode: transactions,
                  default_language,
                  // menus: menus,
                  // menus_type: menus_type,
                  images: responseImages.data.images,
                  minlevel: response.data.minlevel,
                  mail: response.data.mail,
                  notify: response.data.notify,
                  translation: response.data.translation,
                  games_folder: response.data.games_folder,
                  category: response.data.category,
                  Site: response.data.site_id,
                  Logo: response.data.logo,
                  Logo2: response.data.logo2,
                  shopItemDefaultFilename: response.data.default_image,
                  name: response.data.name,
                  title_size: response.data.title_size + 'px',
                  title_color: response.data.title_color,
                  border: response.data.border_width + 'px solid #fff',
                  b: parseInt(response.data.border_width),
                  border_radius: parseInt(response.data.border_radius),
                  height_below: (parseInt(response.data.shop_item_height) - parseInt(response.data.shop_item_image_height)).toString() + 'px',
                  cover_whole: response.data.cover_whole,
                  // groups: response.data.groups,
                  show_game_info: response.data.show_game_info, 
                  show_version_info: response.data.show_version_info,
                  show_debug_info: response.data.show_debug_info,
                  displayName: response.data.display_name,
                  borders: response.data.borders,
                  subdomain: response.data.subdomain,
                  shopItems,
                  JWT: player
/*
                  TitleCreateAccount : 'Create a new ' + response.data.name + ' account',
                  TitleEditAccount: 'Update the ' + response.data.name + ' account',
                  MessageAccountCreated: 'Thank you for creating a new ' + response.data.name + ' account.',
                  MessageAccountEdited: 'Your ' + response.data.name + ' account was successfully updated.'
*/
                })        

            if (Main.Instance.IndexState.PLAYERID) {
                    axios.get(Config.promostorePlayerStatsXPlXP + '?player=' + Main.Instance.IndexState.PLAYERID)
                    .then((response5) => {
                        if (response5.data.return.name === 'QueryResultError') {
                            Rest.Login({player: Main.Instance.IndexState.PLAYERID, points: 0, xp: 0, xpl: 0, level: '1', sublevel: '1'})
                        } else Rest.Login(response5.data.return)            
                    }).catch ((Err) => console.log(Err))
                } else {
                axios.get(Config.promostoreServerDecodeJWT + '?player=' + player)
                    .then((response00) => {
                        if (response00.data && response00.data['PLAYERID']) {
                            if (response00.data['ACT_AS_CUSTOMER'])
                                Logic.Type.New (Main.Instance.IndexState, {PLAYERID: +response00.data['PLAYERID'], ACT_AS_CUSTOMER: true})
                            else Logic.Type.New (Main.Instance.IndexState, {PLAYERID: +response00.data['PLAYERID']})
                        } else Logic.Type.New (Main.Instance.IndexState, {PLAYERID:0})
                        axios.get(Config.promostorePlayerStatsXPlXP + '?player=' + response00.data['PLAYERID'])
                        .then((response5) => {
                            if (response5.data.return.name === 'QueryResultError') {
                                Rest.Login({player: response00.data['PLAYERID'], points: 0, xp: 0, xpl: 0, level: '1', sublevel: '1'})
                            } else Rest.Login(response5.data.return)
    
                        }).catch ((Err) => console.log(Err))
                    })
                    }
                }).catch ((err) => console.log(err))
            }).catch ((err) => console.log(err))
        }).catch ((err) => console.log(err))
      if (callback0) {
        callback0(false)
      }

      if (callback) {
        callback()
      }

      if (callback1) {
        callback1()
      }
   
    } else {
      return undefined
    } 
  }).catch ((err) => console.log(err))
  
  return undefined
}


// WEBPACK FOOTER //
// ./src/Views/Main/Index/Init.tsx